import React, {Component} from 'react';
import Styles from './style.css';
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";

class HeaderMobileMenuDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            reseller: false,
            options: {
                home: false,
                advertise: false,
                about: false
            },
            menu: false,
            layout: false
        }
    };

    componentWillMount() {
        this._updateLayout();
        this._updateUser();
        this._updateLang();
        this._updateLanguages();
    }

    _updateLayout() {
        try {
            this.setState({layout: this.props.layout, lang: langRegister.lang()});
        } catch (e) {}
    }

    _updateUser() {
        let user = userRegister.get();
        try {
            this.setState({
                user: user,
                reseller: user.reseller,
                inhouse: user.inhouse,
                reseller_type: user.reseller_type
            });
        } catch (e) {
        }
        if(user.socialData){
            this.setState({
                settlements: user.socialData.settlements? user.socialData.settlements : false
            });
        }
    }

    _updateLang(){
        this.setState({
            lang: langRegister.lang()
        });
    }

    _updateLanguages(){
        let languages = JSON.parse(salesChannelRegister.get('languages'));
        if(Array.isArray(languages)){
            this.setState({languages: languages});
        }
    }

    _updateMarket(){
        this.setState({market: salesChannelRegister.get('market')});
    }

    _signout() {
        userRegister.remove();
        tokenRegister.remove();
        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
    }

    _openMenu() {
        this.setState({menu: true});
    }

    _closeMenu() {
        this.setState({menu: false});
    }

    _open(option) {
        this.state.options[option] = !this.state.options[option];
        this.setState({options: this.state.options});
    }

    _scrollTo(element) {
        let offSet = 0, timeout = null;
        element = document.getElementById(element);
        if (element) {
            const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
            window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
            this.setState({menu: false});
        }
    }

    _signup() {
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
        } catch (e) {
        }
    }

    _register() {
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/register");
        } catch (e) {
        }
    }

    _profile() {
        try {
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/running");
        } catch (e) {
        }
    }

    _help(){
        window.open('https://help.'+dataRegister.domain+"/"+salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name'), '_blank');
    }

    _login() {
        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/login");
    }

    _setLang(lang) {
        langRegister.set(lang);
        this.props.props.history.replace("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/running");
        window.location.reload();
    }

    _renderLanguage(lang){
        let value = "";
        for(let i = 0; i < this.state.languages.length; i++){
            if(this.state.languages[i].code === lang){
                value = this.state.languages[i].names[langRegister.lang()];
            }
        }
        return value;
    }

    _terms(value){
        window.open('https://legal.'+dataRegister.domain+"/"+ salesChannelRegister.get('market') + "/" + langRegister.lang() + "/"+value+"/" + salesChannelRegister.get('name'), '_blank');
    }

    _renderText(item) {
        return langRegister.get("mobile-menu-dashboard", item);
    }

    render() {
        return (
            <div>
                <div className={
                    cx(Styles.menu,
                        {
                            [Styles.menuOpen]: this.state.menu,
                        })
                }>
                    <div className={Styles.menuInner}>
                        <img className={Styles.menuInnerLogo} src={salesChannelRegister.get('logo_mobile')}/>
                        <img onClick={() => this._closeMenu()} className={Styles.menuInnerClose} src={require("../../assets/images/cross_icon.png")}/>
                        {
                            this.state.reseller && !this.state.inhouse &&
                            <div className={Styles.menuVipStatus}>
                                VIP
                            </div>
                        }
                        {
                            this.state.inhouse &&
                            <div className={Styles.menuInhouseStatus}>
                                INHOUSE
                            </div>
                        }
                        <div className={Styles.menuInnerOptions}>
                            <div className={Styles.menuInnerOptionsItem}>
                                <div onClick={() => this._open('campaigns')} className={Styles.menuInnerOptionsItem}>
                                    {
                                        this.state.options.campaigns &&
                                        <div className={Styles.menuInnerOptionsItemIcon}>–</div>
                                        ||
                                        <div className={Styles.menuInnerOptionsItemIcon}>+</div>
                                    }
                                    <div
                                        className={Styles.menuInnerOptionsItemText}>{this._renderText("item_1")}
                                    </div>
                                </div>
                                <div className={
                                    cx(Styles.menuInnerOptionsItemDropdown,
                                        {
                                            [Styles.menuInnerOptionsItemDropdownOpen]: this.state.options.campaigns,
                                        })
                                }>
                                    <div onClick={() => {
                                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/running");
                                        this.setState({menu: false})
                                    }}
                                         className={Styles.menuInnerOptionsItemDropdownItem}>
                                        {this._renderText("item_2")}
                                    </div>
                                    <div onClick={() => {
                                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/history");
                                        this.setState({menu: false})
                                    }}
                                         className={Styles.menuInnerOptionsItemDropdownItem}>
                                        {this._renderText("item_3")}
                                    </div>
                                    <div onClick={() => {
                                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/archived");
                                        this.setState({menu: false})
                                    }}
                                         className={Styles.menuInnerOptionsItemDropdownItem}>
                                        {this._renderText("item_17")}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.menuInnerOptionsItem}>
                                <div onClick={() => this._open('billing')} className={Styles.menuInnerOptionsItem}>
                                    {
                                        this.state.options.billing &&
                                        <div className={Styles.menuInnerOptionsItemIcon}>–</div>
                                        ||
                                        <div className={Styles.menuInnerOptionsItemIcon}>+</div>
                                    }
                                    <div
                                        className={Styles.menuInnerOptionsItemText}>{this._renderText("item_4")}
                                    </div>
                                </div>
                                <div className={
                                    cx(Styles.menuInnerOptionsItemDropdown,
                                        {
                                            [Styles.menuInnerOptionsItemDropdownOpen]: this.state.options.billing,
                                        })
                                }>
                                    <div onClick={() => {
                                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/billing/receipts");
                                        this.setState({menu: false})
                                    }}
                                         className={Styles.menuInnerOptionsItemDropdownItem}>
                                        {this._renderText("item_5")}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.menuInnerOptionsItem}>
                                <div className={Styles.menuInnerOptionsItem}>
                                    <div onClick={() => {
                                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/profile");
                                        this.setState({menu: false})
                                    }} className={Styles.menuInnerOptionsItemText}>{this._renderText("item_6")}
                                    </div>
                                </div>
                            </div>
                            <div className={
                                cx(Styles.menuInnerOptionsItem,
                                    {
                                        [Styles.menuInnerOptionsItemLast]: !this.state.reseller && !this.state.inhouse
                                    })
                            }>
                                <div className={Styles.menuInnerOptionsItem}>
                                    <div onClick={() => {
                                        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/settings");
                                        this.setState({menu: false})
                                    }} className={Styles.menuInnerOptionsItemText}>{this._renderText("item_14")}
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.reseller || this.state.inhouse) &&
                                <div className={
                                    cx(Styles.menuInnerOptionsItem,
                                        {
                                            [Styles.menuInnerOptionsItemLast]: (this.state.reseller || this.state.inhouse) && !this.state.settlements //this.state.reseller_type !== "commission"
                                        })
                                }>
                                    <div className={Styles.menuInnerOptionsItem}>
                                        <div onClick={() => {
                                            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/insights");
                                            this.setState({menu: false})
                                        }} className={Styles.menuInnerOptionsItemText}>{this._renderText("item_16")}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                (this.state.reseller || this.state.inhouse) && this.state.settlements && //this.state.reseller_type === "commission" &&
                                <div className={
                                    cx(Styles.menuInnerOptionsItem,
                                        {
                                            [Styles.menuInnerOptionsItemLast]: true
                                        })
                                }>
                                    <div className={Styles.menuInnerOptionsItem}>
                                        <div onClick={() => {
                                            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/settlements");
                                            this.setState({menu: false})
                                        }} className={Styles.menuInnerOptionsItemText}>{this._renderText("item_18")}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className={Styles.dropdown}>
                                <select className={Styles.dropdownSelection} value={this.state.lang} onChange={(event) => this._setLang(event.target.value)}>
                                    {
                                        this.state.languages.map((item, key) => {
                                            return(
                                                <option key={key} value={item.code}>{item.names[langRegister.lang()]}</option>
                                            )
                                        })
                                    }
                                </select>
                                <div className={Styles.dropdownText}>
                                    {this._renderLanguage(this.state.lang)}
                                </div>
                                <img className={Styles.dropdownArrow}
                                     src={require("../../assets/images/arrow_grey.svg")}/>
                            </div>

                            <div className={Styles.divider}/>

                            <div onClick={() => this._signup()} className={Styles.button}>
                                {this._renderText("item_8")}
                            </div>
                            {
                                this.state.user &&
                                <div onClick={() => this._signout()} className={Styles.button}>
                                    {this._renderText("item_9")}
                                </div>
                            }
                            {
                                !this.state.user &&
                                <div onClick={() => this._login()} className={Styles.button}>
                                    {this._renderText("item_10")}
                                </div>
                            }
                            <div className={Styles.terms}>
                                <span onClick={() => this._terms("terms")}>{this._renderText("item_11")}</span> | <span onClick={() => this._terms("privacy")}>{this._renderText("item_12")}</span> | <span onClick={() => this._terms("acceptance")}>{this._renderText("item_13")}</span>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.state.menu &&
                    <div className={Styles.overlay}/>
                }
            </div>
        );
    }
}

export default HeaderMobileMenuDashboard;


// WEBPACK FOOTER //
// ./src/components/header-mobile-menu-dashboard/component.js